import MOTUS from "../../constants/motus";

import "./index.scss";

const TrustBadge = () => {
  const tooltip = `${MOTUS.LEGAL_BUSINESS_NAME}\n${MOTUS.EMAIL}\n${MOTUS.PHONE}\n${MOTUS.ADDRESS}`;

  return (
    <p className="trust-badge" title={tooltip}>
      MOTUS Filer #{MOTUS.FILER_NUMBER} &middot; {MOTUS.LEGAL_BUSINESS_NAME} &middot;{" "}
      {MOTUS.CAPABILITY} (registered, not government-affiliated)
    </p>
  );
};

export default TrustBadge;
